module.exports = __webpack_public_path__ + "img/play_text_top.09405f1f.png";